import React, {useState, useEffect} from 'react'
import { Table } from 'react-bootstrap'
import { useAuth } from '../../context/auth';
import { hasRight, isAdmin } from '../../Helpers';
import axios from 'axios'
import { SERVER_API } from '../../fileWithConstants';
import toast from 'react-hot-toast';
const PoInwarddetails = ({poChildData}) => {
  const [warehouse, setWarehouse] = useState({});
  const [auth, setAuth] = useAuth();
  const admin_right = isAdmin(auth.user);
  const unique_no_right = hasRight(auth.user, 'po_unique_no');

  const getWareHouse = async()=>{
          try {
              const {data} = await axios.get(`${SERVER_API}/api/v1/supplier/get-warehouse`);
              if(data?.success && data?.wdata.length>0){
                  /* console.log(data) */

                  const warehouseMap = {};
                data?.wdata?.forEach(element => {
                  warehouseMap[element.id] = element.name;
                });
                setWarehouse(warehouseMap);
                  //setWarehouse(data?.wdata);
              }else{
                toast.error('Some thing went wrong while getting Warehouse data.')
              }
          } catch (error) {
              console.log(error)
          }
      }
      useEffect(()=>{
          getWareHouse();
      },[])

      const totalQuantity = poChildData.reduce(
          (sum, po) => sum + (Number(po.inw_qty) || 0),
          0
        );

        const totalAmount = poChildData.reduce(
          (sum, po) => sum + (Number(po.inw_amount) || 0),
          0
        );

  return (
    <Table striped bordered hover>
        <thead>
        <tr>
            <th>#</th>
            <th>PO No.</th>
            <th>Fabric</th>
            <th>Fabric(Supplier)</th>
            <th>Warehouse</th>
            <th>Than No.</th>
            <th>Quantity</th>
            <th>Short</th>
            <th>Excess</th>
            <th>Unit</th>
            <th>Price</th>
            <th>Dis %</th>
            <th>Amount INR</th>
            {(unique_no_right || admin_right) && (
              <th>Unique No.</th>
            )}
        </tr>
        </thead>
        <tbody>
            {poChildData.map((po,index)=>(
            <tr key={index}>
                <td>{index+1}</td>
                <td>{po.po_num}</td>
                <td className='text-start'>{po.name}</td>
                <td className='text-start'>{po.supplierfbname}</td>
                <td className='text-start'>{warehouse[po.warehouse]}</td>
                <td>{po.than_no}</td>
                <td>{po.inw_qty}</td>
                <td>{po.sort}</td>
                <td>{po.excess}</td>
                <td>{po.unit}</td>
                <td>{po.inw_price}</td>
                <td>{po.inw_discount}</td>
                <td>{po.inw_amount}</td>
                {(unique_no_right || admin_right) && (
                  <td>{po.unique_no}</td>
                )}
            </tr>
            ))}
            <tr>
                <td colSpan={6} className="text-end">
                    <strong>Total:</strong>
                </td>

                <td><strong>{totalQuantity}</strong></td>

                <td colSpan={5}></td>

                <td>
                    <strong>{totalAmount.toFixed(2)}</strong>
                </td>

                {(unique_no_right || admin_right) && (
                    <td></td>
                )}
            </tr>
        </tbody>
        
    </Table>
  )
}

export default PoInwarddetails
